import type { ModuleMigrationDef } from "@kubdee/sdk";

export const migration: ModuleMigrationDef = {
  key: "002_procurement_control",
  version: "1.1.0",
  sql: `
    ALTER TABLE \`purchase_order_items\` ADD COLUMN \`received_qty\` real NOT NULL DEFAULT 0;
    ALTER TABLE \`purchase_order_items\` ADD COLUMN \`received_amount\` real NOT NULL DEFAULT 0;
    ALTER TABLE \`purchase_order_items\` ADD COLUMN \`billed_qty\` real NOT NULL DEFAULT 0;
    ALTER TABLE \`purchase_order_items\` ADD COLUMN \`billed_amount\` real NOT NULL DEFAULT 0;

    CREATE TABLE IF NOT EXISTS \`purchase_matching_policies\` (
      \`id\` text PRIMARY KEY NOT NULL,
      \`company_id\` text NOT NULL,
      \`name\` text NOT NULL,
      \`is_default\` integer DEFAULT 0 NOT NULL,
      \`qty_tolerance_pct\` real DEFAULT 0 NOT NULL,
      \`qty_tolerance_qty\` real DEFAULT 0 NOT NULL,
      \`price_tolerance_pct\` real DEFAULT 0 NOT NULL,
      \`price_tolerance_amount\` real DEFAULT 0 NOT NULL,
      \`tax_tolerance_amount\` real DEFAULT 0 NOT NULL,
      \`over_receipt_action\` text DEFAULT 'block' NOT NULL,
      \`over_billing_action\` text DEFAULT 'block' NOT NULL,
      \`require_approval\` integer DEFAULT 1 NOT NULL,
      \`created_by\` text,
      \`created_at\` text NOT NULL,
      \`updated_by\` text,
      \`updated_at\` text NOT NULL
    );
    CREATE INDEX IF NOT EXISTS \`pcm_company_idx\` ON \`purchase_matching_policies\` (\`company_id\`, \`is_default\`);

    CREATE TABLE IF NOT EXISTS \`purchase_landed_costs\` (
      \`id\` text PRIMARY KEY NOT NULL,
      \`landed_cost_no\` text NOT NULL,
      \`company_id\` text NOT NULL,
      \`branch_id\` text,
      \`posting_date\` text NOT NULL,
      \`allocation_method\` text DEFAULT 'amount' NOT NULL,
      \`clearing_account_id\` text NOT NULL,
      \`total_amount\` real DEFAULT 0 NOT NULL,
      \`status\` text DEFAULT 'draft' NOT NULL,
      \`remarks\` text,
      \`gl_entry_ids\` text,
      \`created_by\` text,
      \`created_at\` text NOT NULL,
      \`updated_by\` text,
      \`updated_at\` text NOT NULL
    );
    CREATE UNIQUE INDEX IF NOT EXISTS \`purchase_landed_costs_no_unique\` ON \`purchase_landed_costs\` (\`landed_cost_no\`);
    CREATE INDEX IF NOT EXISTS \`plc_company_status_idx\` ON \`purchase_landed_costs\` (\`company_id\`, \`status\`, \`posting_date\`);

    CREATE TABLE IF NOT EXISTS \`purchase_landed_cost_lines\` (
      \`id\` text PRIMARY KEY NOT NULL,
      \`landed_cost_id\` text NOT NULL,
      \`charge_type\` text NOT NULL,
      \`description\` text,
      \`amount\` real DEFAULT 0 NOT NULL,
      \`sort_order\` integer DEFAULT 0 NOT NULL,
      \`created_at\` text NOT NULL
    );
    CREATE INDEX IF NOT EXISTS \`plcl_landed_cost_idx\` ON \`purchase_landed_cost_lines\` (\`landed_cost_id\`);

    CREATE TABLE IF NOT EXISTS \`purchase_landed_cost_allocations\` (
      \`id\` text PRIMARY KEY NOT NULL,
      \`landed_cost_id\` text NOT NULL,
      \`goods_receipt_id\` text NOT NULL,
      \`goods_receipt_item_id\` text NOT NULL,
      \`item_id\` text NOT NULL,
      \`warehouse_id\` text NOT NULL,
      \`base_amount\` real DEFAULT 0 NOT NULL,
      \`allocated_amount\` real DEFAULT 0 NOT NULL,
      \`created_at\` text NOT NULL
    );
    CREATE INDEX IF NOT EXISTS \`plca_landed_cost_idx\` ON \`purchase_landed_cost_allocations\` (\`landed_cost_id\`);
    CREATE INDEX IF NOT EXISTS \`plca_receipt_item_idx\` ON \`purchase_landed_cost_allocations\` (\`goods_receipt_id\`, \`goods_receipt_item_id\`);
  `,
};
